import { rawConverter } from "@api/models/objects/Converters";
import { QueryParametersInterface } from "@api/repositories/interfaces/QueryParametersInterface";
import { ObjectRepository } from "@api/repositories/ObjectRepository";
import { DropDownItem } from "@share/common/drop-down/types";
import { SelectSourceParams, SelectSourceServiceInterface } from "@share/common/types/interfaces/select-control/SelectSourceServiceInterface";
import Axios, { CancelTokenSource } from "axios";
import { ElementConverter } from "@api/repositories/types/ElementConverter";
import {ElementInterface} from "@api/models/interfaces/ElementInterface";

export class SelectObjectSourceService implements SelectSourceServiceInterface {

    private cancelToken: CancelTokenSource | null = null;

    constructor(
        private objectRepository: ObjectRepository,
        private converter: ElementConverter<ElementInterface> = rawConverter,
        private include: (string | Record<string, string[]>)[] = []
    ) {

    }

    async getSelectSource(params: SelectSourceParams) {
        return (await this.loadData(params)).map(item => Object.freeze(item));
    }

    private loadData({ keyword, schemaId, eventId, withoutParents, onlyParents, parentsIds, searchableFields = ['title'], keywordLength = 3 }: SelectSourceParams): Promise<DropDownItem<string>[]> {
        if(!schemaId) {
            throw new Error(`schemaId is ${schemaId}. SchemaId is required.`);
        }
        if (keyword.length < keywordLength) {
            return new Promise((resolve) => { resolve([]) });
        }

        if (this.cancelToken) {
            this.cancelToken.cancel();
        }

        const parts: string[] = keyword.split(' ');
        const words: string[] = parts.map((part: string) => `(?i).*${part}.*`);

        let query: QueryParametersInterface = {
            take: 30,
            include: ['title', 'id', ...this.include],
            order: {
                title: 'asc'
            },
            where: {
                $search: [
                    searchableFields,
                    words
                ],
                ...(eventId ? { eventId: eventId } : null ),
                ...(withoutParents ? {parentId: { $exists: true }} : null),
                ...(onlyParents || parentsIds ? {
                    parentId: {
                        ...(onlyParents ? { $exist: false } : null),
                        ...(parentsIds ? { $in: parentsIds } : null)
                    }
                } : null)

            }
        };

        this.cancelToken = Axios.CancelToken.source();

        return this.objectRepository.query(schemaId, query, this.converter, {
            cancelToken: this.cancelToken.token
        }) as any;
    }
}
